import React from 'react'
import { kgDivision } from '../../../Store'

const BidGroup = ({ bidGroup }) => {
    
    const getNameById = (kgKubun) => {
        const item = kgDivision.find((item) => kgKubun == item.id)
        return item ? item.name : 'Not Found'
    }
    const kgKubunName = getNameById(bidGroup.kgKubun)

    const averageSuryo =
        bidGroup?.kgSuryo != null && bidGroup?.suryo != null && bidGroup.suryo !== 0
        ? (bidGroup.kgSuryo / bidGroup.suryo).toFixed(1)
        : (0).toFixed(1)
    //===============================================
    // Css
    //===============================================
    const container = {
        backgroundColor:'#fff',border : '1px solid #ababab',borderRadius : '10px', padding : '10px', width: '100%', marginBottom: '10px'
    }
    const bidStatus1 = {
        padding:'7px 10px 0px 10px', margin:'5px', backgroundColor:'red',color:'#fff', fontSize:'16px', fontWeight: 'bold', width:'100px'
    }
    const bidStatus8 = {
        padding:'7px 10px 0px 10px', margin:'5px', backgroundColor:'#ffa500',color:'#fff', fontSize:'16px', fontWeight: 'bold', width:'100px'
    }
    const bidStatus9 = {
        padding:'7px 10px 0px 10px', margin:'5px', backgroundColor:'#006400',color:'#fff', fontSize:'16px', fontWeight: 'bold', width:'100px'
    }
    const bidTime = {
        padding:'5px', margin:'5px', color:'#305496', fontSize:'20px', fontWeight: 'bold'
    }
    const gyoshu = {
        fontSize:'20px', fontWeight:'bold', textDecoration:'underline'
    }
    const bidDetail = {
        fontSize:'20px', fontWeight:'normal',
    }
    return (
        
            <div style={{borderRadius : '10px', width: '100%'}}>
                <div style={container}>
                    <div style={{display : 'flex',}}>
                            {
                                bidGroup.groupStatus == 1 ?
                                <div style={bidStatus1}>入札中</div>
                                :
                                <></>
                            }
                            {
                                bidGroup.groupStatus == 8 ?
                                <div style={bidStatus8}>開票中</div>
                                :
                                <></>
                            }
                            {
                                bidGroup.groupStatus == 9 ?
                                <div style={bidStatus9}>入札終了</div>
                                :
                                <></>
                            }
                        <div style={bidTime}>
                            <span>{bidGroup.startTime}</span>
                            ～
                            <span>{bidGroup.endTime}</span>
                        </div>
                    </div>
                    <div style={gyoshu}>{bidGroup.displayGyoshu}</div>
                    {
                        bidGroup.kgKubun ?
                        <div style={gyoshu}>{bidGroup.senmei} / {bidGroup.kgSuryo}Kg</div>
                        :
                        <div style={gyoshu}>{bidGroup.senmei} / {bidGroup.suryo}箱</div>

                    }
                    <div style={bidDetail}>
                        <div>
                            {
                                bidGroup.kgKubun ?
                                <>
                                    数量：<span>{bidGroup.suryo}</span> /
                                </>
                                :
                                <>
                                    キロ数：<span>{averageSuryo}</span> /
                                </>
                            }
                            単位：<span>{kgKubunName}</span> / 
                            容器：<span>{bidGroup.yoki}</span>
                        </div>
                    </div>
                </div>
            </div>
        
    )
  }
  
  export default BidGroup
